$(document).ready(function () {

	(function () {
		('use strict');
		const headerTop = document.querySelector('.header_top');
		const floatingNotch = document.querySelector('.floating-notch');
		const toFormBtn = document.querySelectorAll('.banner a, .intro .floating-notch');
		const toFormBtnHome = document.querySelector('.banner .home-to-form');

		/***** SCROLL TO FORM EVENT LISTENER *****/
		if (navigator.userAgent.toLowerCase().indexOf('chrome') < 0) {
			if (window.location.pathname === '/') {
				// scrollToForm(toFormBtnHome);
			} else {
				for (let i = 0; i < toFormBtn.length; i++) {
					// scrollToForm(toFormBtn[i]);
				}
			}
		}

		if (floatingNotch) {
			floatingNotch.innerHTML = `
			<div class="notch-outer">
				<div class="notch-text">
					<p>Book your free<br> initial consultation</p>
				</div>
				<img src="/images/svg/consult.svg" alt="Consultation" width="236" height="95">
			</div>
		`;
			// Change Notch behaviour upon scroll.
			window.addEventListener('scroll', function () {
				if (window.pageYOffset > 885) {
					floatingNotch.classList.add('active');
				} else {
					floatingNotch.classList.remove('active');
				}
			});
		}

		// Formula for ease transition - Source: http://gizma.com/easing/
		function easeInOutCubic(t, b, c, d) {
			t /= d / 2;
			if (t < 1) return (c / 2) * t * t * t + b;
			t -= 2;
			return (c / 2) * (t * t * t + 2) + b;
		}

		/***** ADD TRANSPARENCY TO HEADER *****/
		if (window.location.pathname === '/') {
			headerTop.classList.add('transparent');
		} else {
			headerTop.classList.remove('transparent');
		}

		/********* REUSABLE SCROLL TO FORM FUNCTION *******/
		function scrollToForm(getElement) {
			return getElement.addEventListener('click', function (e) {
				e.preventDefault();
				const targetId = e.currentTarget.getAttribute('href');
				const targetPosition = document.querySelector(`${targetId}`).offsetTop;
				const startPosition = window.pageYOffset;
				const distance = targetPosition - startPosition;
				const duration = 1000;
				let start;

				function step(timestamp) {
					if (start === undefined) start = timestamp;
					const elapsed = timestamp - start;

					window.scrollTo(
						0,
						easeInOutCubic(elapsed, startPosition, distance, duration)
					);

					if (elapsed < duration) {
						window.requestAnimationFrame(step);
					}
				}
				window.requestAnimationFrame(step);
			});
		}

		// Function highlights current page Active URL 
		function activePageURL(linkElements, linkClass) {
			const currentUrl = location.href;
			const dropdownLink = document.querySelector('.dropdown')
			document.querySelectorAll(linkElements).forEach(link => {
				if (link.href === currentUrl || link.getAttribute("href") === "") {
					link.classList.add(linkClass);
					dropdownLink && link.closest('.dropdown')?.querySelector('.nav-link').classList.add('activeLink')
				}
			})
		}

		// Confirmation before proceeding to outside link
		function confirmation() {
			const elements = document.querySelectorAll('.confirmation')
			elements?.forEach(element => {
				element.addEventListener('click', (e) => {
					if (!confirm("Please be aware that by continuing, you will be leaving the Lonsdale website. Please note that Lonsdale is not responsible for the accuracy of the information contained within the linked site(s) accessible from this page.")) e.preventDefault()
				}, false)
			})
		}

		activePageURL(".navbar-nav > li > a", "activeLink");
		activePageURL(".dropdown-menu > li > a", "dropdown-active");
		confirmation()
	})();

	(function () {
		const header = document.querySelector("[data-header]");
		let headerIntersect = document.querySelector("[data-observer-intercept]")

		function addWatcherToHeaderOnScroll() {
			const scrollableWatcher = document.createElement("div")
			scrollableWatcher.setAttribute('data-observer-intercept', '')
			header?.before(scrollableWatcher)
			headerIntersect = document.querySelector("[data-observer-intercept]")
		}

		function setHeaderShadow() {
			const onIntersect = (entries) => {
				entries.forEach(entry => {
					header?.toggleAttribute("data-header-box-shadow", !entry.isIntersecting)
				});
			}

			const observer = new IntersectionObserver(onIntersect)
			observer.observe(headerIntersect)
		}

		function setMainElementToMatchHeader() {
			const headerObserver = new ResizeObserver(entries => {

				for (let entry of entries) {
					const main = document.querySelector("main")
					main.style.paddingBlockStart = `${entry.borderBoxSize[0].blockSize}px`
				}
			})

			headerObserver.observe(header)
		}

		addWatcherToHeaderOnScroll()
		setHeaderShadow()
	})()

});
